// extracted by mini-css-extract-plugin
export default {"empty-query-root":"EmptyQuery_empty-query-root__tEsRC","blob-content":"EmptyQuery_blob-content__XxLwM"};